import zhTWLocale from "element-ui/lib/locale/lang/zh-TW";

const cntw = {
  // 单词类
  "登录":"登錄",
  "公司":"公司",
  "主页":"主頁",
  "设定":"設定",
  "退出":"登出",
  "努力加载中":"努力加載中",
  "全部":"全部",
  "所有记录":"所有記錄",
  "海关报表":"海關報表",
  "客户记录":"客戶記錄",
  "会员管理": "會員管理",
  "资金管理":"資金管理",
  "资金结余":"資金結餘",
  "账户管理":"賬戶管理",
  "设定汇率":"設定匯率",
  "小票设定":"小票設定",
  "权限管理":"權限管理",
  "账号管理":"賬號管理",
  "兑换买入":"兌換買入",
  "兑换卖出":"兌換賣出",
  "货币汇款":"貨幣匯款",
  "现金结余": "現金結餘",
  "银行结余": "銀行結餘",
  "设置汇率":"設置匯率",
  "":"",

  // element多语言
  ...zhTWLocale
}

export default cntw
